import { IconButton, Menu, MenuButton, MenuList, useStyleConfig } from '@chakra-ui/react';
import { RiMoreFill } from 'react-icons/ri';
import DropdownMenuOption from './DropdownMenuOption';
import {
  setResume, onLink,
} from '../../../handlers';
import { addResume,  } from '../utils';

const DropdownNav = ({ props, formikProps, resumeIndex }) => {
  const stateProps = props.stateProps;

  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  const values = formikProps.values;
  const isComplete = !!(props.stateProps.dataToSave.saved.resumes[resumeIndex]['industry'] && props.stateProps.dataToSave.saved.resumes[resumeIndex]['job_title']);
  return (
    <Menu placement="bottom-end">
      {({ isOpen }) => (
        <>
        <MenuButton
            as={IconButton}
            sx={{...buttonStyles.tertiary,...buttonStyles.icon}}
            margin={1}
            marginRight={4}
            icon={<RiMoreFill />}
          />
          <MenuList
            sx={{ minWidth: '144px', padding: '0', borderRadius: '6px' }}
          >
            { isComplete && (<DropdownMenuOption
              onClick={() => setResume(props, resumeIndex)}
            >
              Resume Menu
            </DropdownMenuOption> )}
            { isComplete && (<DropdownMenuOption
              onClick={() =>
                addResume(
                  props,
                  values.jobSeekerData[resumeIndex]
                )
              }
            >
              Duplicate
            </DropdownMenuOption> )}
            { isComplete && (
            <DropdownMenuOption
              onClick={() => onLink(false, formikProps, stateProps, 'preview', 0, 'section', resumeIndex)}
            >
              Preview
            </DropdownMenuOption>
            )}
            <DropdownMenuOption
              onClick={() =>
                props.stateProps.setEditableIndex(resumeIndex)
              }
            >
              Edit
            </DropdownMenuOption>
          </MenuList>
        </>
      )}
    </Menu>
  );
};
export default DropdownNav;
/*

            { isComplete && (<DropdownMenuOption
              onClick={e =>
                onDownload(e, formikProps, props.stateProps, resumeIndex)
              }
            >
              Download
            </DropdownMenuOption> )}
 */